import { z } from 'zod';
import { Organization } from 'libs/end-to-end/src/types/organizations/organization';
import { DataRule } from 'libs/end-to-end/src/data-rules';
import { GenerateReportControllerResult } from 'libs/end-to-end/src/generate-report';
import { GenerateReportRequest } from 'libs/end-to-end/src/generate-report';
import { DashboardAISummaryStatus } from 'libs/end-to-end/src/dashboard-ai-summary/dashboard-ai-summary-types';
import { ProsemirrorOutput } from 'libs/end-to-end/src/prosemirror';

export const GenerateDashboardAISummaryStateMachineInput = z.object({
  organization: Organization,
  dashboardId: z.string(),
  databaseId: z.string(),
  databaseRevisionId: z.string(),
  dashboardAISummaryId: z.string(),
  dataRules: DataRule.array(),
  rootHash: z.string(),
});

export type GenerateDashboardAISummaryStateMachineInput = z.infer<
  typeof GenerateDashboardAISummaryStateMachineInput
>;

export const GenerateDashboardAISummaryControllerResult = z.object({
  dashboardAISummaryId: z.string(),
  dashboardId: z.string(),
});

export type GenerateDashboardAISummaryControllerResult = z.infer<
  typeof GenerateDashboardAISummaryControllerResult
>;

export const GenerateDashboardAISummaryRequest = z.object({
  generateReportRequest: GenerateReportRequest,
  context: z.string().optional(),
});

export type GenerateDashboardAISummaryRequest = z.infer<
  typeof GenerateDashboardAISummaryRequest
>;
